import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from "../button/button.component";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
  selector: 'ui-link',
  template: `
    <ui-button
      buttonType="text"
      iconPosition="right"
      [icon]="icon()"
      class="p-0 hover:bg-opacity-0 hover:text-inherit focus:bg-white"
      (buttonClick)="handleLinkClick()"
    >
      <ng-content></ng-content>
    </ui-button>
  `
})

export class LinkComponent {
  icon = input<string>('icons:right');
  linkClick = output<void>();

  handleLinkClick() {
    this.linkClick.emit();
  }
}
